import { Route } from "react-router";

import { queryClient } from "@/providers/QueryClient";
import { loadSearchTablePreferences } from "@/shared/domain/config/loaders/loadSearchTablePreferences";
import { QueryTarget } from "@/shared/domain/query";
import { makeViewsLoader } from "@/shared/domain/views/loaders/loadViews";
import { composeLoaders } from "@/shared/routing/composeLoaders";

import { File } from "./File";
import { FilesPage } from "./FilesPage";

// See `DatasetsRoutes`: preferences, plus the `?view=` View when there is one.
const filesListLoader = composeLoaders(
  loadSearchTablePreferences(queryClient, "file_search_table_preferences"),
  makeViewsLoader(queryClient, { target: QueryTarget.Files }),
);

export const FilesRoutes = () => [
  <Route key="/" index loader={filesListLoader} element={<FilesPage />} />,
  <Route
    key="detail"
    path=":fileId/:workspaceId?"
    loader={File.loader(queryClient)}
    element={<File.Component />}
    errorElement={<File.ErrorBoundary />}
  />,
];
